import { render, staticRenderFns } from "./ActiveShipmentDP.vue?vue&type=template&id=4bf048ed&scoped=true"
import script from "./ActiveShipmentDP.vue?vue&type=script&lang=js"
export * from "./ActiveShipmentDP.vue?vue&type=script&lang=js"
import style0 from "./ActiveShipmentDP.vue?vue&type=style&index=0&id=4bf048ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf048ed",
  null
  
)

export default component.exports